<template>
  <v-container>
    <div>
      <div v-if="$store.getters.getLanguage === 0">注意事项：带<span class="red--text">*</span>为必填项，请如实填写。</div>
      <div v-if="$store.getters.getLanguage === 1">Note: fields with <span class="my-auto red--text">*</span> are required, please fill in truthfully.</div>
      <v-form ref="form" class="mt-4">
        <!-- 姓名 -->
        <v-row no-gutters v-if="false">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$t('lang.name')}}</span>
          </v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-text-field v-model="name" outlined clearable required dense :rules="nameRules"></v-text-field>
          </v-col>
        </v-row>
        <!-- 电话/邮箱 -->
        <v-row no-gutters v-if="false">
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
            <span class="my-auto red--text">*</span>
            <span class="my-auto">{{$t('lang.phoneOrEmail')}}</span>
          </v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-text-field v-model="phone" outlined clearable required dense :rules="phoneOrEmailRules"></v-text-field>
          </v-col>
        </v-row>
        <!-- 自定义项 -->
        <v-list v-if="false">
          <v-list-item v-for="(item, i) in info.CustomItemList" :key="i" class="pa-0 d-inline">
            <!-- 文本框 -->
            <div class="text" v-if="item.ItemType === 1">
              <!-- 电话 手机 身份证 其他证件-->
              <v-row no-gutters v-if="item.ItemRule !== 1 && item.ItemRule !== 6">
                <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
                </v-col>
                <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                  <v-text-field v-if="item.ItemRule === 0 ||item.ItemRule === 2 || item.ItemRule === 5" v-model="info.CustomItemList[i].Content" outlined clearable required dense :rules="nullRules"></v-text-field>
                  <v-text-field v-if="item.ItemRule === 3" v-model="info.CustomItemList[i].Content" outlined clearable required dense :rules="phoneRules"></v-text-field>
                  <v-text-field v-if="item.ItemRule === 4" v-model="info.CustomItemList[i].Content" outlined clearable required dense :rules="idsRules"></v-text-field>
                </v-col>
              </v-row>
              <!-- 日期选择 -->
              <v-row v-if="item.ItemRule === 1">
                <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
                </v-col>
                <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                  <v-menu v-model="info.CustomItemList[i].model" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field outlined required dense v-model="info.CustomItemList[i].Content" readonly v-bind="attrs" v-on="on"></v-text-field>
                    </template>
                    <v-date-picker v-model="info.CustomItemList[i].Content" no-title scrollable :locale="$store.getters.getLanguage === 0 ? 'zh-CN' : 'en-US'" @input="info.CustomItemList[i].model = false">
                    </v-date-picker>
                    <!-- <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                      <v-btn text color="primary" @click="$refs.menu.save(date)">OK</v-btn> -->
                  </v-menu>
                </v-col>
              </v-row>
              <!-- 区域选择 -->
              <div v-if="item.ItemRule === 6">
                <v-row>
                  <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                    <span class="my-auto red--text">*</span>
                    <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
                  </v-col>
                  <v-col cols="12" sm="10">
                    <v-radio-group v-model="info.CustomItemList[i].areaSwitch" row mandatory class="ma-0 pa-0">
                      <v-radio :label="$t('lang.china')" :value="true"></v-radio>
                      <v-radio :label="$t('lang.otherCountry')" :value="false"></v-radio>
                    </v-radio-group>
                    <v-text-field v-if="!info.CustomItemList[i].areaSwitch" :placeholder="$t('lang.otherCountryName')" v-model="info.CustomItemList[i].otherCountry" outlined clearable required dense></v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="info.CustomItemList[i].areaSwitch">
                  <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="ma-0 pa-0">
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-select placeholder="选择省份" v-model="info.CustomItemList[i].selectProvince" outlined dense :items="info.CustomItemList[i].province" item-text="ProName" item-value="ProID" required @change="provinceEvent(info.CustomItemList[i].selectProvince)"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-select placeholder="选择城市" v-model="info.CustomItemList[i].selectCity" outlined dense :items="info.CustomItemList[i].city" item-text="CityName" item-value="CityID" required @change="cityEvent(info.CustomItemList[i].selectCity)"></v-select>
                  </v-col>
                  <v-col class="d-flex" cols="12" sm="2">
                    <v-select placeholder="选择区" v-model="info.CustomItemList[i].selectDistrict" outlined dense :items="info.CustomItemList[i].district" item-text="DisName" item-value="Id" required @change="districtEvent(info.CustomItemList[i].selectDistrict)"></v-select>
                  </v-col>
                  <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 5 : 4">
                    <v-text-field placeholder="详细地址" v-model="info.CustomItemList[i].detail" outlined clearable required dense></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </div>
            <!-- 文本域 -->
            <v-row v-if="item.ItemType === 2">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-textarea name="input-7-1" outlined auto-grow v-model="info.CustomItemList[i].Content" :rules="nullRules"></v-textarea>
              </v-col>
            </v-row>
            <!-- 单选 -->
            <v-row v-if="item.ItemType === 3">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-0 pt-0">
                  <span class="my-auto red--text">*</span>
                  <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" sm="10" class="mt-0 pt-0">
                <v-radio-group v-model="info.CustomItemList[i].Content" class="mt-0 pt-0">
                  <v-radio v-for="n in $store.getters.getLanguage === 0 ? item.ItemOption.split(',') : item.ItemOptionEnglish.split(',')" :key="n" :label="n" :value="n"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <!-- 多选 -->
            <v-row v-if="item.ItemType === 4">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-0 pt-0">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" sm="10" class="mt-0 pt-0">
                <v-checkbox class="mt-0 " v-for="(item, n) in $store.getters.getLanguage === 0 ? item.ItemOption.split(',') : item.ItemOptionEnglish.split(',')" :key="n" :label="item" :value="item" v-model="info.CustomItemList[i].Content"></v-checkbox>
              </v-col>
            </v-row>
            <!-- 下拉 -->
            <v-row v-if="item.ItemType === 5">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
                <v-select outlined dense :items="$store.getters.getLanguage === 0 ? item.ItemOption.split(',') : item.ItemOptionEnglish.split(',')" v-model="info.CustomItemList[i].Content" required></v-select>
              </v-col>
            </v-row>
            <!-- 上传 -->
            <v-row v-if="item.ItemType === 6">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
                <span class="my-auto red--text">*</span>
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-row>
                <v-col cols="12" sm="10" v-if="info.CustomItemList[i].Content">
                  <van-image fit="cover" lazy-load height="120" width="120" :src="info.CustomItemList[i].Content"></van-image>
                </v-col>
                <v-col cols="12" sm="4">
                  <v-file-input v-model="info.CustomItemList[i].file" accept="image/*" outlined dense prepend-icon="" prepend-inner-icon="mdi-camera" show-size placeholder="上传文件" @change="uploadImg()"></v-file-input>
                </v-col>
              </v-row>
            </v-row>
            <!-- 关联组？ -->
            <div>
            </div>
            <!-- 备注 -->
            <v-row v-if="item.ItemType === 8">
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2" class="mt-2">
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemName : item.ItemNameEnglish}}</span>
              </v-col>
              <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10" class="mt-2">
                <span class="my-auto">{{$store.getters.getLanguage === 0 ? item.ItemOption : item.ItemOptionEnglish}}</span>
              </v-col>
            </v-row>
          </v-list-item>
        </v-list>
        <v-row >
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 1 : 2">
              <span class="my-auto red--text">*</span>
              <span class="my-auto">退款原因</span>
          </v-col>
          <v-col cols="12" :sm="$store.getters.getLanguage === 0 ? 11 : 10">
            <v-textarea name="input-7-1" outlined auto-grow v-model="refundNotes" :rules="nullRules"></v-textarea>
          </v-col>
        </v-row>
      </v-form>
      <div class="my-6 d-flex justify-space-around justify-sm-center">
        <v-btn class="mx-sm-10" style="text-transform:none;" color="primary" @click="$emit('fatherEvent', 'back')">{{$t('lang.back')}}</v-btn>
        <v-btn color="primary" style="text-transform:none;" @click="submit()" :loading="loading">{{$t('lang.submit')}}</v-btn>
      </div>
    </div>
    <v-snackbar v-model="snackbar" timeout="2000" centered color="primary" multi-line>
      {{ msg }}
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
          {{$t('lang.close')}}
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import CityJson from '../utils/CityJson'
import DistrictJson from '../utils/DistrictJson'
import ProJson from '../utils/ProJson'
export default {
  name: 'Refund',
  props: ['data'],
  data: () => ({
    atid: 0,
    costId: 0,
    snackbar: false,
    msg: '',
    name: '',
    phone: '',
    nullRules: [],
    nameRules: [],
    phoneRules: [],
    phoneOrEmailRules: [],
    emailRules: [],
    idsRules: [],
    info: {},
    loading: false,
    refundNotes: ''
  }),
  computed: {
    note () {
      return this.$store.getters.getLanguage === 0 ? this.data.Notes : this.data.NotesEnglish
    }
  },
  mounted () {
    // this.getSignUpInfo()
  },
  methods: {
    initRoles () {
      this.nullRules = [
        v => !!v || this.$t('lang.cannotBeEmpty')
      ]
      this.nameRules = [
        v => !!v || this.$t('lang.nameCannotBeEmpty')
      ]
      this.phoneRules = [
        v => !!v || this.$t('lang.phoneCannotBeEmpty'),
        v => (v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || this.$t('lang.correctPhone')
      ]
      this.emailRules = [
        v => !!v || this.$t('lang.emailCannotBeEmpty'),
        v => (v && /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd]+[-.])+[A-Za-zd]{2,5}$/.test(v)) || this.$t('lang.correctEmail')
      ]
      this.phoneOrEmailRules = [
        v => !!v || this.$t('lang.phoneOrEmailCannotBeEmpty'),
        v => (v && ((v && v.length === 11 && /^1[3456789]\d{9}$/.test(v)) || /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([A-Za-zd0-9]+[-.])+[A-Za-zd]{2,5}$/.test(v))) || this.$t('lang.correctPhoneOrEmail')
      ]
      this.idsRules = [
        v => !!v || this.$t('lang.idsCannotBeEmpty'),
        v => (v && /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(v)) || this.$t('lang.correctIds')
      ]
    },
    getSignUpInfo () {
      this.$http.get('/SignUp/GetSignupInfo', {
        requestBase: 'VUE_APP_API',
        params: {
          Sid: this.$store.getters.getRefundSignUpIdStr,
          Atid: 0,
          CostId: 0
        }
      }).then(res => {
        if (res.data.ret === 0) {
          console.log(res.data.data)
          this.info = res.data.data
          for (let index = 0; index < this.info.CustomItemList.length; index++) {
            const element = this.info.CustomItemList[index]
            if (element.ItemType === 1 && element.ItemRule === 1) {
              // this.info.CustomItemList[index].model = false
              // 添加新属性要用this.$set方法，不能直接添加
              this.$set(this.info.CustomItemList[index], 'model', false)
              this.info.CustomItemList[index].Content = new Date().toISOString().substr(0, 10)
            }
            if (element.ItemType === 4) {
              this.info.CustomItemList[index].Content = []
            }
            if (element.ItemType === 5) {
              this.info.CustomItemList[index].Content = this.$store.getters.getLanguage === 0 ? this.info.CustomItemList[index].ItemOption.split(',')[0] : this.info.CustomItemList[index].ItemOptionEnglish.split(',')[0]
            }
            if (element.ItemType === 6) {
              this.$set(this.info.CustomItemList[index], 'file', null)
            }
            if (element.ItemType === 1 && element.ItemRule === 6) {
              this.$set(this.info.CustomItemList[index], 'areaSwitch', true)
              this.$set(this.info.CustomItemList[index], 'detail', null)
              this.$set(this.info.CustomItemList[index], 'otherCountry', null)
              this.$set(this.info.CustomItemList[index], 'province', ProJson)
              this.$set(this.info.CustomItemList[index], 'city', [])
              this.$set(this.info.CustomItemList[index], 'district', [])
              this.$set(this.info.CustomItemList[index], 'selectProvince', null)
              this.$set(this.info.CustomItemList[index], 'selectCity', null)
              this.$set(this.info.CustomItemList[index], 'selectDistrict', null)
              this.$set(this.info.CustomItemList[index], 'selectProvinceName', '')
              this.$set(this.info.CustomItemList[index], 'selectCityName', '')
              this.$set(this.info.CustomItemList[index], 'selectDistrictName', '')
            }
          }
          this.initRoles()
        } else {
          this.msg = res.data.msg
          this.snackbar = true
        }
      }).catch(e => {
        console.log(e)
      })
    },
    uploadImg (f) {
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.file) {
          console.info(element.file)
          const formData = new FormData()
          formData.append('files', element.file)
          this.$http({
            method: 'post',
            requestBase: 'VUE_APP_API',
            url: '/SignUp/UploadFiles',
            data: formData
          }).then(res => {
            console.log(res.data)
            if (res.data.ret === 0) {
              console.log(res.data.data)
              this.info.CustomItemList[index].file = null
              this.info.CustomItemList[index].Content = res.data.msg
            } else {
              this.msg = res.data.msg
              this.snackbar = true
            }
          }).catch(e => {
            console.log(e)
          })
        }
      }
    },
    submit () {
      this.initRoles()
      if (this.$refs.form.validate()) {
        this.loading = true
        this.$http({
          method: 'post',
          requestBase: 'VUE_APP_API',
          url: '/SignUp/RefundUserSignup',
          data: {
            // SignUpId: this.$store.getters.getRefundSignUpId,
            UserSignUpId: this.$store.getters.getUserSignUpId,
            RefundNotes: this.refundNotes
          }
        }).then(res => {
          this.loading = false
          if (res.data.ret === 0) {
            console.log(res.data)
            this.$emit('showSnack', res.data.msg)
            this.$emit('fatherEvent', 'back')
          } else {
            this.msg = res.data.msg
            this.snackbar = true
          }
        }).catch(e => {
          this.loading = false
          console.log(e)
        })
      }
    },
    provinceEvent (val) {
      console.log(val)
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.selectProvince === val) {
          for (let a = 0; a < ProJson.length; a++) {
            const element1 = ProJson[a]
            if (element1.ProID === element.selectProvince) {
              this.info.CustomItemList[index].selectProvinceName = element1.ProName
              break
            }
          }
          const city = []
          for (let b = 0; b < CityJson.length; b++) {
            const element2 = CityJson[b]
            if (element2.ProID === val) {
              city.push(element2)
            }
          }
          this.info.CustomItemList[index].city = city
        }
      }
    },
    cityEvent (val) {
      console.log(val)
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.selectCity === val) {
          for (let a = 0; a < CityJson.length; a++) {
            const element1 = CityJson[a]
            if (element1.CityID === element.selectCity) {
              this.info.CustomItemList[index].selectCityName = element1.CityName
              break
            }
          }
          const district = []
          for (let b = 0; b < DistrictJson.length; b++) {
            const element2 = DistrictJson[b]
            if (element2.CityID === val) {
              district.push(element2)
            }
          }
          this.info.CustomItemList[index].district = district
        }
      }
    },
    districtEvent (val) {
      console.log(val)
      for (let index = 0; index < this.info.CustomItemList.length; index++) {
        const element = this.info.CustomItemList[index]
        if (element.selectDistrict === val) {
          for (let a = 0; a < DistrictJson.length; a++) {
            const element1 = DistrictJson[a]
            if (element1.Id === element.selectDistrict) {
              this.info.CustomItemList[index].selectDistrictName = element1.DisName
              break
            }
          }
        }
      }
    }
  }
}
</script>
